import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { IZPNotification } from '../models/notification.model';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  private messageSource = new BehaviorSubject(null);
  currentMessage: Observable<IZPNotification> = this.messageSource.asObservable();
  
  constructor() { }

  changeMessage(n: IZPNotification) {
    this.messageSource.next(n);
  }

  getMessage() {
    take(5);
    return this.currentMessage;
  }
  clearMessage() {
    this.changeMessage(undefined);
  }
}
